import React from "react";
import { QqControlsGroupPropsType } from "./qq-controls-group-props.type";
import { QqControlFactory } from "./qq-control-factory";
import { Box } from "@mui/material";
import { QqBundleService } from "../services/qq-bundle.service";

export const QqControlsGroupOpenControl: React.FunctionComponent<QqControlsGroupPropsType> =
  ({ group, dispatch, state }) => {
    const ctrlFactory = new QqControlFactory();

    const qqBundleService = new QqBundleService(state.qqBundle);
    const final = qqBundleService.getFinalQuestionIfExist(state.currentOptions);

    const controls = group.qq
      .map((qq) => {
        if (final && qq.orderNumber > final.orderNumber) return undefined;
        return ctrlFactory.create({ state, dispatch }, qq);
      })
      .reduce((r: any, v: any) => {
        if (v) r.push(v);
        return r;
      }, []);

    return (
      <Box>
        {group.label && <legend>{group.label}</legend>}
        {controls}
      </Box>
    );
  };
